import api from './api';
import type { GoodsReceipt, GoodsReceiptLine, PaginatedResponse } from '../types/venue';

const BASE = '/admin/goods-receipt';

export interface PostReceiptResult {
  message: string;
  receiptId: string;
  movementsCreated: number;
  poStatus: string;
}

const goodsReceiptService = {
  getReceipts: async (purchaseOrderId: string): Promise<PaginatedResponse<GoodsReceipt>> => {
    const response = await api.get(BASE, { params: { purchaseOrderId, pageSize: 100 } });
    return response.data;
  },

  getReceiptLines: async (receiptId: string): Promise<PaginatedResponse<GoodsReceiptLine>> => {
    const response = await api.get(`${BASE}/${receiptId}/line`, { params: { pageSize: 500 } });
    return response.data;
  },

  createReceipt: async (data: {
    purchaseOrderId: string;
    venueId: string;
    receivedDate: string;
    receivedBy: string;
    notes?: string;
  }): Promise<GoodsReceipt> => {
    const response = await api.post(BASE, data);
    return response.data;
  },

  createReceiptLine: async (
    receiptId: string,
    data: {
      purchaseOrderLineId: string;
      inventoryItemId: string;
      receivedQty: number;
      unitCostAtReceipt?: number;
    },
  ): Promise<GoodsReceiptLine> => {
    const response = await api.post(`${BASE}/${receiptId}/line`, data);
    return response.data;
  },

  /** Fix 6: create all receipt lines in one request. displayName/locationName are server-side. */
  createReceiptLinesBatch: async (
    receiptId: string,
    lines: Array<{
      purchaseOrderLineId: string;
      inventoryItemId: string;
      receivedQty: number;
      unitCostAtReceipt?: number;
    }>,
  ): Promise<GoodsReceiptLine[]> => {
    const response = await api.post(`${BASE}/${receiptId}/lines/batch`, lines);
    return response.data;
  },

  postReceipt: async (receiptId: string): Promise<PostReceiptResult> => {
    const response = await api.post(`${BASE}/${receiptId}/post`);
    return response.data;
  },
};

export default goodsReceiptService;
